import React from 'react'
import { FaFileDownload } from "react-icons/fa";
import TextWIcon from './TextWIcon';


export default function TextWFileIcon(props) {
  const {
    iconPlacement="before",
    text
  } = props
  return (
    <>
      <TextWIcon 
        text={text}
        icon={<FaFileDownload />}
        iconPlacement={iconPlacement}
      />
    </>
  )
}
